// extracted by mini-css-extract-plugin
export default {"wrapper":"RegistrationLayout_wrapper__m7A+A"};